<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div
      class="modal-header"
      v-text="'Rejection reason:'"
    />
    <div class="modal-body">
      <textarea
        v-model="rejectionReason"
        class="input"
        cols="30"
        rows="10"
      />
      <p
        class="mt-0 italic text-grey-darker text-sm mb-6"
        v-text="'This will be emailed to the user.'"
      />
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn"
        :class="{ load: isLoading }"
        :disabled="!rejectionReason"
        :aria-disabled="!rejectionReason"
        @click="rejectAccessRequest"
        v-text="buttonText"
      />
      <a
        v-if="!isLoading"
        href="#"
        class="mx-4 px-2"
        @click="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'RejectAccessRequestModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    accessRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      rejectionReason: '',
    }
  },
  computed: {
    buttonText() {
      return this.isLoading
        ? 'Rejecting...'
        : 'Reject'
    },
  },
  methods: {
    rejectAccessRequest() {
      this.isLoading = true

      this.$api.active().post(`membership/access-requests/${this.accessRequest.uuid}/reject`, {
        rejection_reason: this.rejectionReason,
      }).then(() => {
        this.isLoading = false

        this.$store.commit('baseAddNotification', {
          type: 'success',
          title: 'Success',
          text: 'Access request rejected and the user has been notified.',
        })

        this.$emit('accessRequestHasBeenRejected', this.accessRequest)

        this.close()
      }).catch(() => {
        this.isLoading = false

        this.$store.commit('baseAddNotification', {
          type: 'error',
          title: 'Error',
          text: 'There was a problem rejecting the access request.',
        })
      })
    },
    close() {
      if(!this.isLoading) {
        this.rejectionReason = ''

        this.$emit('close')
      }
    },
  },
}
</script>
